/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Received_StatusInputs */

const en_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaration received.`)
};

const de_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklärung eingegangen.`)
};

const fr_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déclaration reçue.`)
};

const es_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Declaración recibida.`)
};

const it_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dichiarazione ricevuta.`)
};

const nl_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verklaring ontvangen.`)
};

const pl_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oświadczenie otrzymane.`)
};

const fi_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ilmoitus vastaanotettu.`)
};

const da_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erklæring modtaget.`)
};

const sv_consumer_declaration_received_status = /** @type {(inputs: Consumer_Declaration_Received_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förklaring mottagen.`)
};

/**
* | output |
* | --- |
* | "Declaration received." |
*
* @param {Consumer_Declaration_Received_StatusInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_received_status = /** @type {((inputs?: Consumer_Declaration_Received_StatusInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Received_StatusInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_received_status(inputs)
	if (locale === "fr") return fr_consumer_declaration_received_status(inputs)
	if (locale === "es") return es_consumer_declaration_received_status(inputs)
	if (locale === "it") return it_consumer_declaration_received_status(inputs)
	if (locale === "nl") return nl_consumer_declaration_received_status(inputs)
	if (locale === "pl") return pl_consumer_declaration_received_status(inputs)
	if (locale === "fi") return fi_consumer_declaration_received_status(inputs)
	if (locale === "da") return da_consumer_declaration_received_status(inputs)
	if (locale === "sv") return sv_consumer_declaration_received_status(inputs)
	return en_consumer_declaration_received_status(inputs)
});